import React, { useEffect } from 'react';
import { HubSpotForm } from './contact-form.styled';

export interface ContactFormProps {
  portalId: string;
  formId: string;
}

declare global {
  interface Window {
    hbspt: {
      forms: {
        create: (config: { portalId: string; formId: string; target: string }) => void;
      };
    };
  }
}

const ContactForm = ({ formId, portalId }: ContactFormProps): JSX.Element => {
  const form: string = formId || 'bd8782ba-eb90-4a39-a116-6e63f1066ce1';

  useEffect(() => {
    if (!formId) return;

    const script = document.createElement('script');
    script.src = 'https://js.hsforms.net/forms/embed/v2.js';
    document.body.appendChild(script);

    script.addEventListener('load', () => {
      if (window.hbspt) {
        window.hbspt.forms.create({
          portalId,
          formId: formId || '',
          target: `#hubspot-form-${formId || ''}`,
        });
      }
    });
  }, [formId, portalId]);

  return <HubSpotForm id={`hubspot-form-${form}`} />;
};

export default ContactForm;
